import clsx from 'clsx'
import * as icon from 'react-icons/go'
import { match, P } from 'ts-pattern'
import { WorkflowRunConclusion } from '../../types'

function iconProps(label: string, color: string) {
  return {
    role: 'img' as const,
    'aria-label': label,
    title: label,
    className: clsx('w-5 h-5 shrink-0', color),
  }
}

export function StatusIcon({ conclusion }: { conclusion: WorkflowRunConclusion | null }) {
  return match(conclusion)
    .with('action_required', () => <icon.GoAlertFill {...iconProps('Action required', 'text-status-attention')} />)
    .with('cancelled', () => <icon.GoCircleSlash {...iconProps('Cancelled', 'text-status-muted')} />)
    .with('failure', () => <icon.GoStop {...iconProps('Failure', 'text-status-failure')} />)
    .with('neutral', () => <icon.GoDash {...iconProps('Neutral', 'text-status-muted')} />)
    .with('skipped', () => <icon.GoSkipFill {...iconProps('Skipped', 'text-status-faint')} />)
    .with('stale', () => <icon.GoClock {...iconProps('Stale', 'text-status-stale')} />)
    .with('success', () => <icon.GoCheckCircleFill {...iconProps('Success', 'text-status-success')} />)
    .with('timed_out', () => <icon.GoStopwatch {...iconProps('Timed out', 'text-status-failure')} />)
    .otherwise(() => <icon.GoQuestion {...iconProps('No conclusion', 'text-status-muted')} />)
}

export function statusRowClassName(conclusion: WorkflowRunConclusion | null) {
  return clsx(
    'border-l-4',
    match(conclusion)
      .with(P.union('failure', 'timed_out'), () => 'border-l-status-failure bg-status-failure/10')
      .otherwise(() => 'border-l-transparent'),
  )
}
